import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import WithField from '../../../../../../Resource/FormTemplates/Inputs/WithField';
import { T } from '../../../../../../Translations';
import FlashError from '../../../../../FlashMessage/FlashError';
import { Ready } from '.././Types';
import Form from './Form';

interface Props {
  state: Ready;
  submitting: () => void;
}

function ReadyView({ state, submitting }: Props) {
  return (
    <WithField kind="single-selection" name="product_license_ids" fields={state.template.fields}>
      {(field) =>
        fromArrayMaybe(state.resource.payload.allocatableLicenses)
          .map(() => <Form field={field} state={state} submitting={submitting} />)
          .getOrElse(() => (
            <FlashError>
              <T kind="Your organization currently has no available licenses to..." />
            </FlashError>
          ))
      }
    </WithField>
  );
}

export default observer(ReadyView);
